const LocalStorageAvailable = (storageType) => {

    const storageByType = {
        persist: typeof globalThis !== 'undefined' ? globalThis.localStorage : null,
        session: typeof globalThis !== 'undefined' ? globalThis.sessionStorage : null
    };
    const storage = storageByType[storageType];

    if (!storage) {
        return false;
    }

    const test = 'nearpeer:storage-availability-test';
    try {
        storage.setItem(test, test);
        storage.removeItem(test);
        return true;
    }
    catch (e){
        return false;
    }
};

module.exports = LocalStorageAvailable;
